import { render, staticRenderFns } from "./tiaoma.vue?vue&type=template&id=30434ff0&"
import script from "./tiaoma.vue?vue&type=script&lang=js&"
export * from "./tiaoma.vue?vue&type=script&lang=js&"
import style0 from "./tiaoma.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports